export default "__VITE_ASSET__aF1YVlZc__"